module.exports = __webpack_public_path__ + "static/media/icon-upload.673eda27.svg";